module.exports = __webpack_public_path__ + "img/b26dfd87d4430c5790ef063e75cb9a42.png";